import useNthRoot from "./use-nth-root";

export default function useCalculateToDouble(apr: number): number {
  const percentage: number = apr / 100.0;
  const aprPlusOne: number = percentage + 1;
  return useNthRoot(aprPlusOne, 12) - 1;
}
